import { useState, useEffect } from "react";
import api from "../api/axiosConfig";
import "../css/adminDashboard.css";
import { useNavigate } from "react-router-dom";

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState("student");
  const [usersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const navigate = useNavigate();

  // FIX: Spaces ko hatakar hyphens use kiye hain taaki URL clean bane aur dynamic route match ho sake
  const cardsConfig = [
    { id: "student", label: "Students", icon: "🎓" },
    { id: "teacher", label: "Teachers", icon: "👩‍🏫" },
    { id: "principal", label: "Principals", icon: "🏛️" },
    { id: "career-counsellor", label: "Career Counsellors", icon: "🤝" },
    { id: "coaching-partner", label: "Coaching Partners", icon: "📚" }
  ];

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      setError("");
      setSelectedUser(null);
      try {
        // FIX: Agar backend endpoint space accept karta hai (jaise "coaching partner"), 
        // toh hum hyphen ko wapas space se replace karke API hit kar rahe hain.
        const apiTabName = activeTab.replace("-", " ");
        const response = await api.get(`/admin/users/${apiTabName}`);
        
        if (response.data && response.data.success) {
          setUsersData(response.data.data || []);
        } else {
          setUsersData([]);
        }
      } catch (err) {
        console.error("API Error:", err);
        setError(`Failed to fetch ${activeTab} data.`);
        setUsersData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [activeTab]);

  return (
    <div className="admin-dashboard-container">
      <div className="dashboard-header-title">
        <h2>Admin Management Panel</h2>
        <p>Select a category from the sidebar to view data entries</p>
      </div>

      <div className="admin-main-split-layout">
        <div className="admin-cards-vertical-column">
          {cardsConfig.map((card) => (
            <div 
              key={card.id} 
              className={`admin-stat-card ${activeTab === card.id ? "active-card" : ""}`}
              onClick={() => setActiveTab(card.id)}
            >
              <div className="card-icon">{card.icon}</div>
              <div className="card-info">
                <h3>{card.label}</h3>
                <span>View Records</span>
              </div>
            </div>
          ))}
        </div>

        <div className="dashboard-dynamic-content">
          {loading && <div className="loading-spinner-text">🔄 Fetching {activeTab} list...</div>}
          {!loading && error && <div className="error-message-alert">⚠️ {error}</div>}

          {!loading && !error && (
            <div className="dashboard-content-layout">
              <div className="table-wrapper-box">
                {usersData.length === 0 ? (
                  <p className="no-data-text">No users found under "{activeTab}" yet.</p>
                ) : (
                  <table className="admin-custom-table">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Full Name</th>
                        <th>Email</th>
                        <th>Phone Number</th>
                        <th>City</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {usersData.map((user, index) => (
                        <tr key={user.id || user._id || index}>
                          <td data-label="S.No">{index + 1}</td>
                          <td data-label="Full Name">{user.fullName || "N/A"}</td>
                          <td data-label="Email">{user.email}</td>
                          <td data-label="Phone">{user.phoneNumber || "N/A"}</td>
                          <td data-label="City">{user.city || "N/A"}</td>
                          <td data-label="Actions">
                            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                              <button 
                                onClick={() => setSelectedUser(user)} 
                                style={{ cursor: 'pointer', backgroundColor: '#052F5F', color: '#fff', border: 'none', padding: '6px 10px', borderRadius: '4px' }}
                              >
                                Quick Info
                              </button>
                              
                              <button 
                                onClick={() => navigate(`/admin/${activeTab}/${user.id || user._id}`, { 
                                  state: { viewMode: "admin", user: user } 
                                })} 
                                style={{ cursor: 'pointer', backgroundColor: '#4CA926', color: '#fff', border: 'none', padding: '6px 10px', borderRadius: '4px' }}
                              >
                                Full Profile
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>

              {selectedUser && (
                <div className="activity-detail-modal-panel">
                  <div className="panel-header" style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'15px' }}>
                    <h4 style={{ margin:0, color: '#1e293b' }}>Quick Info</h4>
                    <button onClick={() => setSelectedUser(null)} style={{ background:'none', border:'none', fontSize:'1.5rem', cursor:'pointer', color: '#64748b' }}>×</button>
                  </div>
                  <div className="profile-summary-card">
                    <h5 style={{ margin: '0 0 8px 0', fontSize: '1rem', color: '#0f172a' }}>{selectedUser.fullName}</h5>
                    <p style={{ fontSize:'0.85rem', color:'#475569', lineHeight: '1.4' }}>
                      <strong>State:</strong> {selectedUser.state || "N/A"}<br />
                      <strong>Role:</strong> {selectedUser.role}<br />
                      <strong>Message:</strong> {selectedUser.message || "No custom message provided."}
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;